/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { openItemsTableStyles } from "@eisinc/App/Widgets/PaymentCenter/OpenItemsTable";
import { FormInputWrapper } from "@eisinc/MobiusOverrides/FormField";
import { color } from "@eisinc/XDL/Utilities";
import { showAllTabPagination } from "@eisinc/XDL/Utilities/sharedStyles";
import xScreen from "@eisinc/XDL/Utilities/xScreen";
import { StyledButton } from "@insite/mobius/Clickable";
import DataTableCellBase from "@insite/mobius/DataTable/DataTableCellBase";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

openItemsTableStyles.noResultsContainer = {
    css: css`
        margin: 32px 0;
    `,
};

openItemsTableStyles.loadingSpinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 15px 0;
        color: ${color("primary.main")};
    `,
};

openItemsTableStyles.headerWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 16px 32px;
        margin: 5px 0 12px;

        ${xScreen("lt", "md")} {
            flex-direction: column;
            align-items: flex-start;
        }
    `,
};

openItemsTableStyles.dateRangeSelect = {
    cssOverrides: {
        formField: css`
            ${xScreen("gt", "xs")} {
                flex-direction: row;
                align-items: center;
                gap: 12px;

                &&& ${FormInputWrapper} {
                    margin-top: 0;
                }
            }

            label {
                width: fit-content;
                line-height: 17px;
                font-weight: normal;
                color: #2c2c2c;
                white-space: nowrap;
            }
        `,
        formInputWrapper: css`
            min-width: 210px;
        `,
    },
};

openItemsTableStyles.invoicesSummaryContainer = {
    css: css`
        display: flex;
        gap: 6px;
    `,
};

openItemsTableStyles.invoiceSummaryTitle = {
    size: 20,
    lineHeight: "24px",
    css: css`
        ${xScreen("lt", "xs")} {
            font-size: 12px;
        }
    `,
};

openItemsTableStyles.invoiceSummaryTitleCredit = {
    weight: 600,
};

openItemsTableStyles.invoiceSummaryTitleNonCredit = {
    weight: 600,
};

openItemsTableStyles.tableWrapper = {
    css: css`
        overflow: auto;
        ${xScreen("lt", "md")} {
            overflow-x: scroll;
        }
    `,
};

openItemsTableStyles.paginationWrapper = {
    css: css`
        margin-top: 9px;
    `,
};

openItemsTableStyles.pagination = {
    ...showAllTabPagination,
};
